import React from 'react';
import { T } from "../../hooks/useTranslate";

import { Box, Typography } from "@mui/material"
import { styles } from '../../themes/datagrid.styles';

import { ManageColumns } from '../../components/filters/ManageColumns';
import { SortByDropdown } from "../../components/filters/SortByDropdown";
import { MemberSearch } from './MemberSearch';
import { DataGridFilterButtons } from './DataGridFilterButtons';

const DataGridHeadSection = ({
  viewportIsMedium,
  sortModel,
  handleSortModelChange,
  status,
  columnVisibility,
  setColumnVisibility,
  filterModel,
  setFilterModel,
  handlePageChange,
  searchField,
  setSearchField,
  currentInput,
  setCurrentInput,
  clearFilters,
  apiInProgress
}) => {
  return (
    <Box id="data-grid-head-section">
      <Box
        id="data-grid-head-section-row1"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: "24px 24px 24px 24px"
        }}
      >
        <Box sx={{ width: "416px" }}>
          <MemberSearch
            searchField={searchField}
            setSearchField={setSearchField}
            loading={status === "wait"}
            currentInput={currentInput}
            setCurrentInput={setCurrentInput}
            setPage={handlePageChange}
          />
        </Box>
        <Box>
          {viewportIsMedium &&
            <SortByDropdown
              sortModel={sortModel}
              handleSortModelChange={handleSortModelChange}
              loading={status === "wait"}
              searchField={searchField}
            />
          }
        </Box>
      </Box>
      <Box
        id="data-grid-head-section-row2"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: "0px 24px 16px 24px"
        }}>
        <Box sx={{ display: "flex", gap: "8px", alignItems: "baseline" }}>
          <DataGridFilterButtons
            filterModel={filterModel}
            setFilterModel={setFilterModel}
            handlePageChange={handlePageChange}
            apiInProgress={apiInProgress}
          />
          {
            filterModel.length > 0 &&
            <Typography
              onClick={() => clearFilters()}
              sx={styles.clearFiltersLink}>
              <T>clear_filters</T>
            </Typography>
          }
        </Box>
        {
          viewportIsMedium &&
          <ManageColumns
            loading={status === "wait"}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
          />
        }
      </Box>
    </Box>
  )
}

export { DataGridHeadSection }